var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"affiliate-notice"},[_c('h2',[_vm._v("通知設定")]),_c('el-row',[_c('el-col',[_c('NotificationConfig')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }